<template>
  <base-link
    v-if="target?.url"
    class="relative hover:underlined"
    :class="{ 'flex items-center gap-x-1 ': icon }"
    :target="target.targetAttribute"
    :to="target.url"
    @click="handleClick"
  >
    <vf-icon v-if="icon" :dir :name="icon" size="sm" />
    <span v-if="$feature.showTitleHtml" v-html="titleHtml" />
    <span v-else>{{ title }}</span>
  </base-link>
  <div v-else>
    <p v-if="title" class="fw-bold ">
      <span v-if="$feature.showTitleHtml" v-html="titleHtml" />
      <span v-else>{{ title }}</span>
    </p>
    <cms-rich-text v-if="richText" :content="{ richText }" />
  </div>
</template>

<script setup lang="ts">
import type { Icon } from '#types/target'

const props = defineProps<{
  content: any
}>()

const { $gtm } = useNuxtApp()

const {
  target,
  title,
  titleHtml,
  richText,
  icon: { icon, dir } = {} as Icon,
  name,
  delocalizedTracking,
  footerItemL1
} = props.content

const handleClick = () =>
  $gtm.push('footer.onClickFooterLink', `${footerItemL1} | ${delocalizedTracking || name}`)
</script>
